import { render, staticRenderFns } from "./ApiDoc.vue?vue&type=template&id=2e243c62&"
import script from "./ApiDoc.vue?vue&type=script&lang=js&"
export * from "./ApiDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports